/**
 * 关于我们模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request'

// 获取关于我们
export const getAbout = (params) => {
  return req.get('/about/getMessage', params)
}

// 修改关于我们
export const editAbout = (params) => {
  return req.post('/about/updateMessage', params)
}

